module.exports = __webpack_public_path__ + "../static/media/progreso.2ab79d12.png";